import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LgvClientService } from '../../core/services/lgv-client.service';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { environment as env } from '../../../environments/environment';
import { DatePipe } from '@angular/common';
import { LgvTSHelper } from '../../core/utility/ts-helper';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../core/notifications/notification.service';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { first, map, takeUntil, tap } from 'rxjs/operators';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';
import { PPC_PROPERTY_TYPE_LIST, PropertyType } from '../../core/enums/property.enum';
import { LgvPropertyService } from '../../core/services/lgv-property.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lus-buyer-missing-info-modal',
    templateUrl: './buyer-missing-info-modal.component.html',
    styleUrls: ['./buyer-missing-info-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuyerMissingInfoModal implements OnInit, OnDestroy {
    onDestroy$ = new Subject();
    propertyInfoForm: UntypedFormGroup;
    isLoading$ = new BehaviorSubject(false);
    selectedProperty$ = this.LgvClientSvc.SelectedProperty$;

    propertyTypes$ = this.lgvPropertyService.getPropertyTypes().pipe(
        map(propertyTypes => propertyTypes
            .filter(type => PPC_PROPERTY_TYPE_LIST.includes(type.name))
            .sort((a, b) => PPC_PROPERTY_TYPE_LIST.indexOf(a.name) - PPC_PROPERTY_TYPE_LIST.indexOf(b.name))
            .map(propertyType => {
                return {
                    ...propertyType,
                    name: PropertyType[propertyType.name]
                }
            })
        ),
        tap(console.log)
    );

    constructor(
        private fb: UntypedFormBuilder,
        private LgvClientSvc: LgvClientService,
        public LgvUserSvc: LgvUserService,
        public notificationService: NotificationService,
        public dialogRef: MatDialogRef<BuyerMissingInfoModal>,
        public lgvPropertyService: LgvPropertyService,
        private datePipe: DatePipe,
        private http: HttpClient,

    ) { }

    ngOnInit() {
        this.initializeForm();
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }


    initializeForm() {

        this.propertyInfoForm = this.fb.group({
            propertyType: [null, []],
            listingPrice: [null, [RegexValidator(RegexConstants.GREATER_THAN_ZERO)]],
        });

    }


    onSubmit() {
        this.isLoading$.next(true);

        let model = {
            propertyTypeId: this.propertyInfoForm.value.propertyType?.id,
            listingPrice: this.propertyInfoForm.value.listingPrice
        }

        this.LgvClientSvc.updateClientProperty(
            this.LgvClientSvc.ClientID$.value,
            this.LgvClientSvc.SelectedProperty$.value.propertyInfo.id,
            model).pipe(first(), takeUntil(this.onDestroy$)).subscribe(x => {
                this.isLoading$.next(false);
                this.dialogRef.close();
            }, (err) => {
                this.isLoading$.next(false);
                this.notificationService.error('There was an error updating your information');
                console.log(err);

            });
    }

}
